// extracted by mini-css-extract-plugin
module.exports = {"bubble":"Bubble_bubble__1Y0By"};